import { getList, ListType } from '@vimond/services/content-discovery';

export async function fetchMoreAssetsForCarousel(
  listId: string,
  locale: string | undefined,
  page: number,
  size: number,
): Promise<ListType | undefined> {
  return getList(listId, locale, 1, {
    number: page,
    size: size,
  });
}
